import React from "react";
import clsx from "clsx";

import Modal from "../../../atoms/Modal";
import ThreeRulesImg from "../../../assets/images/three_rules.jpg";

import styles from "./ModalThreeRules.module.scss";

export type Props = {
  onClose: () => void;
};
const ModalThreeRules: React.FC<Props> = ({ onClose }) => {
  return (
    <Modal className={clsx(styles.modal)} onClose={onClose}>
      <img src={ThreeRulesImg} alt="three rules" />
    </Modal>
  );
};

export default ModalThreeRules;
